import { render, staticRenderFns } from "./aiTemplate.vue?vue&type=template&id=58481446&scoped=true"
import script from "./aiTemplate.vue?vue&type=script&lang=js"
export * from "./aiTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58481446",
  null
  
)

export default component.exports